"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _LayoutStyles = _interopRequireDefault(require("./LayoutStyles"));

var _LayoutView = _interopRequireDefault(require("./LayoutView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var children = _ref.children,
      showNav = _ref.showNav,
      MainNavigation = _ref.MainNavigation,
      Helmet = _ref.Helmet,
      fixed = _ref.fixed,
      maxWidth = _ref.maxWidth,
      style = _ref.style;
  var classes = (0, _LayoutStyles["default"])();
  var location = (0, _reactRouterDom.useLocation)();
  return /*#__PURE__*/_react["default"].createElement(_LayoutView["default"], {
    MainNavigation: MainNavigation,
    showNav: showNav,
    classes: classes,
    location: location,
    Helmet: Helmet,
    fixed: fixed,
    style: style,
    maxWidth: maxWidth
  }, children);
};

exports["default"] = _default;